import React, { useState } from "react";
import { CssVarsProvider, useColorScheme } from '@mui/joy/styles';
import GlobalStyles from '@mui/joy/GlobalStyles';
import CssBaseline from '@mui/joy/CssBaseline';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Checkbox from '@mui/joy/Checkbox';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import IconButton from '@mui/joy/IconButton';
import Link from '@mui/joy/Link';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Row, Col, Modal } from "react-bootstrap";
import { SlUserUnfollow } from "react-icons/sl";
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ForgotPassword from "../user_registration/ForgotPassowrd";
import SuccessPopUp from "../Utility/SuccessPopUp";
import LoginVerificationModal from "./LoginVerificationModal";
import * as apiUitlity from '../../config/APIUtils';
import ForgotUsername from "../user_registration/ForgotUsername";
import { useNavigate, useParams, Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLoginState, addUserInfo } from '../../config/UserSlice';
import { Alert, DialogContent } from "@mui/joy";
import LoginAlerts from "./LoginAlert";
import { useHomeTheme } from "../../config/HomeThemeProvider";
import ltcLogo from "../header/CARE-LTC-logo.png";
import carePassportLogo from "../header/carepassport logo.png";
import JoyModal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';


//import GoogleIcon from './GoogleIcon';

// interface FormElements extends HTMLFormControlsCollection {
//   email: HTMLInputElement;
//   password: HTMLInputElement;
//   persistent: HTMLInputElement;
// }
// interface SignInFormElement extends HTMLFormElement {
//   readonly elements: FormElements;
// }

function ColorSchemeToggle(props) {
  const { onClick, ...other } = props;
  const { mode, setMode } = useColorScheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => setMounted(true), []);

  return (
    <IconButton
      aria-label="toggle light/dark mode"
      size="sm"
      variant="outlined"
      disabled={!mounted}
      onClick={(event) => {
        setMode(mode === 'light' ? 'dark' : 'light');
        onClick?.(event);
      }}
      {...other}
    >
      {mode === 'light' ? <DarkModeRoundedIcon /> : <LightModeRoundedIcon />}
    </IconButton>
  );
}

export default function Login(props) {
  return (
    <CssVarsProvider>
      <LoginContent {...props} />
    </CssVarsProvider>
  );
}

function LoginContent() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showUserMsg, setShowUserMsg] = useState(false);
  const [userMsg, setUserMsg] = useState('');
  const [verificationModal, setVerificationModal] = useState(false);
  const [show, setshow] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMsg, setsuccessMsg] = useState(false);
  const [showUsername, setShowUsername] = useState(false);
  const [showLoginAlert, setShowLoginAlert] = useState(false);
  const [loginAlertData, setLoginAlertData] = useState({});


  const isNoticeVisible = false;
  const isSuccessNoticeVisible = false;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { home } = useParams() || {};
  const currentHome = home || '';
  const { homeId, setHomeId, config: homeTheme } = useHomeTheme();
  const { mode } = useColorScheme();

  const handleOnChange = e => {
    const { name, value } = e.target;

    switch (name) {
      case "username":
        setUsername(value);
        break;

      case "password":
        setPassword(value);
        break;

      default:
        break;
    }
  };

  const handleOnSubmit = async e => {


    e.preventDefault();
    setVerificationModal(false);
    // if (!username || !password) {
    //   return alert("Fill up all the form!");
    // }
    if (!username || !password) {
      let msg = !password ? "Please enter password!" : "Please enter user id or username!"
      setUserMsg(msg);
      setShowUserMsg(true);
      return;
    }
    try {
      var apiRequest = apiUitlity.apiInputRequest;
      apiRequest.endPoint = "login/";
      apiRequest.data = { user_id_name: username, password: password }
      await apiUitlity.sendAPIDataPOST(apiRequest).then(res => {

        let error = res.data.error;

        if (error === '') {
          if (res.data.token) {
            sessionStorage.setItem("authToken", res.data.token);
          }
          sessionStorage.setItem("userTypeArr", JSON.stringify(res.data.res[0].typeArr));
          sessionStorage.setItem("userId", res.data.res[0].user_id)
          sessionStorage.setItem("userName", res.data.res[0].login_id)
          sessionStorage.setItem("fistName", res.data.newRes[0].firstName)
          sessionStorage.setItem("fullName", res.data.newRes[0].firstName + " " + res.data.newRes[0].lastName);
          sessionStorage.setItem("home_types", JSON.stringify(res.data.appHomeTypeConstants[0].values));
          sessionStorage.setItem("training_providers", JSON.stringify(res.data.training_providers));

          dispatch(setLoginState());
          dispatch(addUserInfo({
            userId: res.data.res[0].user_id,
            userName: res.data.res[0].login_id,
            fullName: res.data.newRes[0].firstName + " " + res.data.newRes[0].lastName,
            userType: res.data.res[0].typeArr.find(t => t.permission_type === "admin" && t.status === "Active") ? "admin" : "user"
          }));

          var typeArr = res.data.res[0].typeArr
          var homeArray = []
          var orgArray = []
          for (var i = 0; i < typeArr.length; i++) {
            if (typeArr[i].permission_type === "organization" && typeArr[i].status === "Active") {
              orgArray.push((res.data.res[0].typeArr[i].permission_of_id))
            }
            else if (res.data.res[0].typeArr[i].permission_type === "home" && res.data.res[0].typeArr[i].status === "Active")
              homeArray.push((res.data.res[0].typeArr[i].permission_of_id))
            else if (res.data.res[0].typeArr[i].permission_type === "admin" && res.data.res[0].typeArr[i].status === "Active") {
              sessionStorage.setItem("userType", "admin")
              return (currentHome ? navigate(`/${currentHome}/admin`) : navigate('/admin'))
            }
          }
          if (orgArray.length !== 0) {
            sessionStorage.setItem("orgId", orgArray[0]);
            sessionStorage.setItem("OtherOrgId", JSON.stringify(orgArray));
            sessionStorage.setItem("homeId", homeArray[0]);
          }
          else {
            if (sessionStorage.getItem("OtherOrgId"))
              sessionStorage.removeItem("OtherOrgId")
            if (sessionStorage.getItem("orgId"))
              sessionStorage.removeItem("orgId")
          }
          if (homeArray.length !== 0) {
            sessionStorage.setItem("allHomeArr", JSON.stringify(homeArray));
            sessionStorage.setItem("homeId", homeArray[0]);
          }

          if (res.data.dobChangeNeeded) {
            let data = { user_id: res.data.newRes[0].user_id, login_id: res.data.newRes[0].userName, fullName: res.data.newRes[0].firstName + " " + res.data.newRes[0].lastName, dob: res.data.newRes[0].dob, password: false }
            setLoginAlertData(data);
            setShowLoginAlert(true);
            return;
          } else {
            return (currentHome ? navigate(`/${currentHome}/user/${res.data.res[0].user_id}`) : navigate(`/user/${res.data.res[0].user_id}`))
          }
        } else {
          //console.log("Login error : ", res.data);
          if (error === 'Not verified') {
            setVerificationModal(true);
          } else if (error === 'Account Deactivated') {
            setUserMsg("Account Deactivated! Please contact administrator to enable.");
            setShowUserMsg(true);
          } else if (error === 'Password Reset Needed') {
            setLoginAlertData(res.data.data);
            setShowLoginAlert(true);
          } else {
            if (res.data === 'Not verified') {
              setVerificationModal(true);
            } else if (res.data === 'Account Deactivated') {
              setUserMsg("Account Deactivated! Please contact administrator to enable.");
              setShowUserMsg(true);
            } else {
              setUserMsg("Invalid Credentials. Please try again.");
              setShowUserMsg(true);
            }
          }
        }

      }).catch(err => {
        setUserMsg("Invalid Credentials inside. Please try again.");
        setShowUserMsg(true);
      })
    } catch (error) {
      setUserMsg("Invalid Credentials. Please try again.");
      setShowUserMsg(true);
    }
  };

  const handleUpdateCallback = (result) => {
    setshow(false);
    setVerificationModal(false);
    setsuccessMsg(result);
    setShowSuccess(true);
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const ltcLogoStyle = {
    width: isMobile ? '100px' : '140px',
    height: isMobile ? '60px' : '90px',
    cursor: 'pointer'
  };

  const passLogoStyle = {
    width: isMobile ? '180px' : '300px',
    height: isMobile ? '30px' : '45px',
    cursor: 'pointer'
  };
  return (
    <>
      {/* <Header /> */}
      <CssBaseline />
      <GlobalStyles
        styles={{
          ':root': {
            '--Form-maxWidth': '800px',
            '--Transition-duration': '0.4s',
          },
        }}
      />
      <Box
        sx={(theme) => ({
          width: { xs: '100%', md: '50vw' },
          transition: 'width var(--Transition-duration)',
          transitionDelay: 'calc(var(--Transition-duration) + 0.1s)',
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          justifyContent: 'flex-end',
          backdropFilter: 'blur(12px)',
          backgroundColor: 'rgba(255 255 255 / 0.2)',
          [theme.getColorSchemeSelector('dark')]: {
            backgroundColor: 'rgba(19 19 24 / 0.4)',
          },
        })}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100dvh',
            width: '100%',
            px: 2,
            mt: { xs: 0, md: 4 },
          }}
        >
          <Box component="header" sx={{ py: 1, display: 'flex', justifyContent: 'space-between' }}>
            <ColorSchemeToggle />
            <IconButton
              aria-label="toggle light/dark mode"
              size="sm"
              variant="outlined"
              onClick={() => (currentHome ? navigate(`/${currentHome}/`) : navigate('/'))}
            >
              {mode === 'light' ? <HomeRoundedIcon /> : <HomeRoundedIcon />}
            </IconButton>


          </Box>
          <Box component="main"
            sx={{
              my: 'auto',
              py: 2,
              pb: 5,
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              width: 500,
              maxWidth: '100%',
              mx: 'auto',
              borderRadius: 'sm',
              '& form': {
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
              },
              [`& .MuiFormLabel-asterisk`]: {
                visibility: 'hidden',
              },
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 4, alignItems: 'center', flexGrow: 1, py: 1 }}>
              <img
                src={ltcLogo}
                alt="Care-ltc-logo"
                style={ltcLogoStyle}
                onClick={() => window.open("https://care-ltc.ca/", '_blank')}
              />
              <img
                src={carePassportLogo}
                alt="Care-passport-logo"
                style={passLogoStyle}
                onClick={() => (currentHome ? navigate(`/${currentHome}/`) : navigate(`/`))}
              />
            </Box>
            {homeTheme?.id !== 'default' &&
              <Box>
                <Typography level="body-xs" mb={1} sx={{ fontStyle: 'italic' }}>In Partnership with .. </Typography>
                {homeTheme && (homeTheme.dark_logo || homeTheme.light_logo) ? (
                  <Box
                    component="img"
                    src={mode === 'dark' ? homeTheme.dark_logo : homeTheme.light_logo}
                    alt={`${homeTheme.title} logo`}
                    sx={{ height: 80, width: 200, mb: 1 }}
                  />
                ) : (
                  <Typography level="h4" component="h1">
                    Care Passport
                  </Typography>
                )}
              </Box>
            }
            {isNoticeVisible && (
              <Alert
                key="notice-board-error"
                variant="soft"
                color="danger"
                startDecorator={<InfoOutlinedIcon />}
                sx={{
                  position: 'sticky',
                  top: 10,
                  zIndex: 10,
                  marginBottom: 2,
                  width: '100%',
                }}
              >
                <Typography level="body-sm" color="info">
                  {/* ** Service Disruption Notice - Aug 29, 2026 - Care Passport will be unavailable due to planned maintenance.  During the upgrade, all features of Care Passport and the Lambton College LTC Training Platform will be unavailable.  Thank you for your patience. */}
                URGENT SERVICE DISRUPTION: In response to the global PHP security vulnerability, the Lambton College training platform has been pro-actively put in maintenance mode while the security patch is implemented.  This is expected to be completed shortly - thank you for your patience.  This vulnerability does not impact access to Care Passport nor the records within but impacts your ability to register for and access courses on the Lambton College platform.
                </Typography>
              </Alert>
            )}
            {isSuccessNoticeVisible && (
              <Alert
                key="notice-board-success"
                variant="soft"
                color="success"
                startDecorator={<InfoOutlinedIcon />}
                sx={{
                  position: 'sticky',
                  top: 10,
                  zIndex: 10,
                  marginBottom: 2,
                  width: '100%',
                }}
              >
               <Typography level="body-sm" color="info">
                        🚀 Portal Update - Aug. 30, 2026 - Care Passport has been updated to improve the user experience!  The updates include direct access to courses via the user's Care Passport account and updated Help documentation.  Pls see: - <a href="https://carepassportcareltc.atlassian.net/wiki/external/NTgwZmU1MjlhZmIzNGJhZjg0YWZiZjkyZTAxNjI5NmI">Care Passport Update</a>.
              </Typography>

                
              </Alert>
            )}
            <Stack gap={4} sx={{ mb: 2 }}>
              <Stack gap={1}>
                <Typography component="h1" level="h3">
                  Sign in
                </Typography>
                <Typography level="body-md">
                  New to portal?{' '}

                  <Link component={RouterLink} to={currentHome ? `/${currentHome}/userRegistration` : '/userRegistration'} level="title-sm">
                    Sign up!
                  </Link>
                </Typography>
              </Stack>
            </Stack>
            <Divider
              sx={(theme) => ({
                [theme.getColorSchemeSelector('light')]: {
                  color: { xs: '#fffffff9', md: 'text.tertiary' },
                },
              })}
            />
            <Stack gap={4} sx={{ mt: 1 }}>
              <form onSubmit={handleOnSubmit}>
                <FormControl>
                  <FormLabel>User ID Number or Username</FormLabel>
                  <Input type="text" name="username" placeholder="Please enter your User ID Number or Username" value={username} onChange={handleOnChange} />
                </FormControl>
                <FormControl required>
                  <FormLabel>Password</FormLabel>
                  <Input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    onChange={handleOnChange}
                    value={password}
                    endDecorator={
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    }
                  />
                </FormControl>
                <Stack gap={4} sx={{ mt: 2 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Checkbox size="sm" label="Remember me" name="persistent" />
                  </Box>
                  <Button type="submit" fullWidth>
                    Sign in
                  </Button>
                  <Row>
                    <Col>
                      <Typography level="body-sm" style={{ display: 'inline-block' }} align="left" sx={{ color: 'text.secondary' }}> Forgot&nbsp; </Typography>
                      <Typography level="body-sm" style={{ color: '#0f6fc5', cursor: 'pointer', display: 'inline-block', textDecoration: 'underline' }} align="left" onClick={() => setShowUsername(true)} sx={{ color: 'text.secondary' }}>Username</Typography>
                      <Typography level="body-sm" style={{ display: 'inline-block' }} align="left" sx={{ color: 'text.secondary' }}> &nbsp;or&nbsp; </Typography>
                      <Typography level="body-sm" style={{ color: '#0f6fc5', cursor: 'pointer', display: 'inline-block', textDecoration: 'underline' }} onClick={() => setshow(true)}>Password?</Typography>
                    </Col>
                  </Row>
                </Stack>
              </form>
            </Stack>
          </Box>
          <Box component="footer" sx={{ py: 2, textAlign: 'center' }}>
            <Typography level="body-sm" textAlign="center">
              © Carepassport {new Date().getFullYear()}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={(theme) => ({
          height: '100%',
          position: 'fixed',
          right: 0,
          top: 0,
          bottom: 0,
          left: { xs: 0, md: '50vw' },
          transition:
            'background-image var(--Transition-duration), left var(--Transition-duration) !important',
          transitionDelay: 'calc(var(--Transition-duration) + 0.1s)',
          backgroundColor: 'background.level1',
          backgroundSize: 'cover',
          backgroundPosition: 'left',
          backgroundRepeat: 'no-repeat',
          backgroundImage:
            (homeTheme && homeTheme.light_logo) ? `url(${homeTheme.light_logo})` : 'url(https://images.unsplash.com/photo-1527181152855-fc03fc7949c8?auto=format&w=1000&dpr=2)',
          [theme.getColorSchemeSelector('dark')]: {
            backgroundImage:
              (homeTheme && homeTheme.dark_logo) ? `url(${homeTheme.dark_logo})` : 'url(https://images.unsplash.com/photo-1572072393749-3ca9c8ea0831?auto=format&w=1000&dpr=2)',
          },
        })}
      >
      </Box>
      <JoyModal open={showUserMsg} onClose={() => setShowUserMsg(false)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} disableScrollLock={true}>
        <ModalDialog sx={{ transition: `opacity 300ms` }}>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, maxWidth: 400 }}>
            <Box
              sx={{
                display: 'inline-block',
                animation: 'shake 0.5s',
                py: 2,
                '@keyframes shake': {
                  '0%': { transform: 'translateX(0)' },
                  '20%': { transform: 'translateX(-8px)' },
                  '40%': { transform: 'translateX(8px)' },
                  '60%': { transform: 'translateX(-8px)' },
                  '80%': { transform: 'translateX(8px)' },
                  '100%': { transform: 'translateX(0)' },
                },
              }}
            >
              <SlUserUnfollow style={{ fontSize: '5pc', color: '#0f6fc5' }} />
            </Box>
           
           <Typography level="body-md" color="text">{userMsg}</Typography>
          </DialogContent>
        </ModalDialog>
      </JoyModal>

      <ForgotPassword show={show} handleUpdateCallback={handleUpdateCallback} onHide={() => { setshow(false); }} />
      <ForgotUsername show={showUsername} handleUpdateCallback={handleUpdateCallback} onHide={() => { setShowUsername(false); }} />
      <SuccessPopUp show={showSuccess} data={successMsg} onHide={() => { setShowSuccess(false); }} />
      <LoginVerificationModal show={verificationModal} username={username} handleUpdateCallback={handleUpdateCallback} onHide={() => { setVerificationModal(false); }} />
      <LoginAlerts show={showLoginAlert} data={loginAlertData} onHide={() => { setShowLoginAlert(false); }} />
    </>
  );
}

